export const CHANGE_ACTIVATION_FORM_FIELD = 'CHANGE_ACTIVATION_FORM_FIELD'
export const ACTIVATION_REQUEST = 'ACTIVATION_REQUEST'
export const ACTIVATION_REQUEST_SUCCESS = 'ACTIVATION_REQUEST_SUCCESS'
export const ACTIVATION_REQUEST_FAILURE = 'ACTIVATION_REQUEST_FAILURE'
export const VALIDATE_ACTIVATION_FIELD = 'VALIDATE_ACTIVATION_FIELD'
export const ADD_ACTIVATION_FIELD_ERROR = 'ADD_ACTIVATION_FIELD_ERROR'
export const CLEAR_ACTIVATION_FIELD_ERROR = 'CLEAR_ACTIVATION_FIELD_ERROR'

export function changeLoginFormField(
  key: string,
  value: string,
): { type: string; payload: { key: string; value: string } } {
  return {
    type: CHANGE_ACTIVATION_FORM_FIELD,
    payload: {
      key,
      value,
    },
  }
}

export interface ActivationRequestPayload {
  password: { value: string; validations?: string }
  password2: { value: string; validations?: string }
  token: { value: string; validations?: string }
}

export function activationRequest(payload: ActivationRequestPayload): {
  type: string
  payload: ActivationRequestPayload
} {
  return {
    type: ACTIVATION_REQUEST,
    payload,
  }
}

export function activationFailure(errors: Record<string, string>): {
  type: string
  errors: Record<string, string>
} {
  return {
    type: ACTIVATION_REQUEST_FAILURE,
    errors,
  }
}

export function activationSuccess(userData: unknown): {
  type: string
  payload: { userData: unknown }
} {
  return {
    type: ACTIVATION_REQUEST_SUCCESS,
    payload: {
      userData,
    },
  }
}

export function addFieldError(payload: { field: string; error: string }): {
  type: string
  payload: { field: string; error: string }
} {
  return {
    type: ADD_ACTIVATION_FIELD_ERROR,
    payload,
  }
}

export function clearFieldError(payload: { field: string }): {
  type: string
  payload: { field: string }
} {
  return {
    type: CLEAR_ACTIVATION_FIELD_ERROR,
    payload,
  }
}

export function validateField(payload: { field: string; value: unknown; validations: string }): {
  type: string
  payload: { field: string; value: unknown; validations: string }
} {
  return {
    type: VALIDATE_ACTIVATION_FIELD,
    payload,
  }
}
